import apiService from "../../../../service/Api";
import { ApiNotificationTemplate, NotificationTemplate, NotificationTemplateFormValues } from "../types/types";

const BASE_URL = "/api/notifications/notification-templates/";

const mapTemplate = (t: ApiNotificationTemplate): NotificationTemplate => ({
  id: String(t.id),
  name: t.name,
  triggerSource: t.trigger_source,
  titleTemplate: t.title_template,
  descriptionTemplate: t.description_template,
  recipientUser: t.recipient_user ?? "",
  recipientGroups: t.recipient_groups,
  isActive: t.is_active,
  updatedAt: t.updated_at,
});

const toApiPayload = (values: NotificationTemplateFormValues) => ({
  name: values.name,
  trigger_source: values.triggerSource,
  title_template: values.titleTemplate,
  description_template: values.descriptionTemplate,
  recipient_user: values.recipientUser || null,
  recipient_groups: values.recipientGroups,
  is_active: values.isActive,
});

export async function fetchNotificationTemplates(): Promise<NotificationTemplate[]> {
  const res = await apiService.get<{ results: ApiNotificationTemplate[] } | ApiNotificationTemplate[]>(
    `${BASE_URL}?page_size=100`,
  );
  const data = Array.isArray(res.data) ? res.data : res.data.results ?? [];
  return data.map(mapTemplate);
}

export async function fetchNotificationTemplate(id: string): Promise<NotificationTemplate> {
  const res = await apiService.get<ApiNotificationTemplate>(`${BASE_URL}${id}/`);
  return mapTemplate(res.data);
}

export async function updateNotificationTemplate(
  id: string,
  values: NotificationTemplateFormValues,
): Promise<NotificationTemplate> {
  const res = await apiService.patch<ApiNotificationTemplate>(`${BASE_URL}${id}/`, toApiPayload(values));
  return mapTemplate(res.data);
}

export async function fetchTriggerVariables(triggerSource: string): Promise<string[]> {
  if (!triggerSource) return [];
  const res = await apiService.get<{ trigger_source: string; variables: string[] }>(
    `${BASE_URL}trigger-variables/?trigger_source=${encodeURIComponent(triggerSource)}`,
  );
  return res.data.variables;
}
